

























import { Component, Vue } from "vue-property-decorator";

@Component
export default class CpgRedirect extends Vue {
  dialog: boolean = true;
  caption: string = "Чтобы вернуться к заявке, нажмите \"Продолжить\"";

  get isMobileBrowser(): boolean {
    return navigator?.userAgentData?.mobile ?? false;
  }
  backToRequest(): void {
    window.location.href = "bank100000000037://online.genbank.ru/client/mobilecpg/";

    setTimeout(() => {
      window.close();
    }, 1500);

  }
}
